export const MILI_SECOND_INTERVAL = 1000;
export const MINUTE_IN_SECONDS = 60;
export const DAYS_IN_HOURS = 24;
